"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Cache store manager.
 */
var CacheStore = /** @class */ (function () {
    function CacheStore() {
        this.stores = {};
    }
    /**
     * Returns store.
     *
     * @param name Name.
     * @returns Map.
     */
    CacheStore.prototype.getStore = function (name) {
        this.stores[name] = this.stores[name] || new Map();
        return this.stores[name];
    };
    return CacheStore;
}());
exports.default = CacheStore;
//# sourceMappingURL=CacheStore.js.map